import React from "react";
import actionCat from "../../images/action-cat.png";
import mobileActionCat from "../../images/mobile/action-cat.png";

import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";

import { ReactComponent as TwitterIcon } from "../../images/twitter-icon.svg";
import telegramIcon from "../../images/telegram.png";

import discordIcon from "../../images/discord-icon.png";
import "./action.css";

function ActionSection({ isMobile, width }) {
  return (
    <section
      id="community"
      className="flex w-full justify-center"
    >
      <div className={`flex ${isMobile ? 'flex-row-reverse' : `${width > 767 && width < 1024 ? '' : 'wrapper'}  flex-row ` } action-wrapper lg:mx-auto`}>
        <img
          src={isMobile ? mobileActionCat : actionCat}
          alt="orange-bg "
          className="action-img"
          style={{ maxHeight: isMobile ? 99 : (width < 1024 ? 240 : 280) }}
        />
        <div className="flex flex-col lg:justify-between action-content">
          <h2 className="text-start action-title">
            Join the community to track the project updates
          </h2>
          <div className="flex items-center lg:flex-nowrap ">
            <a
              href="https://www.facebook.com/HamsterWin-104278365746510"
              target="_blank"
              rel="noreferrer"
              className="flex justify-center social-icons-link"
            >
              <FacebookIcon className="social-icons facebook-icon" />
            </a>
            <a
              href="https://discord.gg/ScGvGXFtY3"
              target="_blank"
              rel="noreferrer"
              className="social-icons-link"
            >
              <img
                src={discordIcon}
                alt="discord-icon"
                className="social-icons"
              />
            </a>
            <a
              href="https://twitter.com/hamster_win"
              target="_blank"
              rel="noreferrer"
              className="social-icons-link"
            >
              <TwitterIcon className="social-icons" />
            </a>
            <a
              href="https://twitter.com/hamster_win"
              target="_blank"
              rel="noreferrer"
              className="social-icons-link"
            >
              <img
                src={telegramIcon}
                className="social-icons"
                alt="telegram-icon"
                style={{}}
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ActionSection;
